import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c5190c6e"
var script = {}


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports